import * as React from 'react';
import { useIntl } from 'react-intl';
import useAnalytics from '../../../hooks/useAnalytics';

interface IWidgetTypeProps {
  title: string;
  value: string;
  active?: boolean;
  handleSelectWidgetType: React.Dispatch<React.SetStateAction<string>>;
}

function WidgetType(props: IWidgetTypeProps): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();

  const handleSelectCategory = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const value = event.currentTarget.getAttribute('data-value');
    if (value) {
      trackEvent(['Widget type', 'click', `Select: ${value}`]);
      props.handleSelectWidgetType(props.active ? '' : value);
    }
  };

  return (
    <button
      className={`e-widget-category ${props.active ? 'active' : ''}`}
      data-value={props.value}
      onClick={handleSelectCategory}
      title={f(
        { id: 'onlineTemplates.subPage.section.widgetTypes.button.tooltip' },
        { name: props.title }
      )}
    >
      {props.title}
    </button>
  );
}

export default WidgetType;
